<template>
  <div class="logsig_2_1">
    <div class="heatab flex">
      <div
        class="tabitem"
        @click="changetype(1)"
        :class="{ tabitemact: 1 == type }"
      >
        个人用户注册
      </div>
      <div
        class="tabitem"
        @click="changetype(2)"
        :class="{ tabitemact: 2 == type }"
      >
        企业用户注册
      </div>
    </div>

    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      class="form"
      
    >
      <el-form-item prop="phone">
        <el-input placeholder="手机号" v-model="form.phone" />
      </el-form-item>

      <el-form-item>
        <div class="formeliten between bornone">
          <el-input class="yzm" placeholder="输入验证码" v-model="form.yzm" />
          <div class="getyzm" v-if="disabled" @click="getyzm">
            {{ yzmtext }}
          </div>
          <div class="getyzm djs" v-if="!disabled">
            {{ yzmtext }}
          </div>
        </div>
      </el-form-item>

      <el-form-item>
        <div class="formeliten pwditem">
          <el-input
            class="pwd"
            :type="pwdshow ? 'text' : 'password'"
            placeholder="输入密码"
            v-model="form.pwd"
          />

          <div class="pwdicon" @click="pwdshow = !pwdshow">
            <svg-icon :icon-class="pwdshow ? 'eye-open' : 'eye'" />
          </div>
        </div>
      </el-form-item>

      <el-form-item >
        <div class="formeliten pwditem">
          <el-input
            class="pwd"
            :type="pwdshow ? 'text' : 'password'"
            placeholder="确认密码"
            v-model="form.pwd2"
          />

          <div class="pwdicon" @click="pwdshow_1 = !pwdshow_1">
            <svg-icon :icon-class="pwdshow ? 'eye-open' : 'eye'" />
          </div>
        </div>
      </el-form-item>

      <el-form-item v-if="type == 2">
        <el-input placeholder="公司名称" v-model="form.mc" />
      </el-form-item>

      <el-form-item v-if="type == 2">
        <el-input placeholder="公司法人" v-model="form.fr" />
      </el-form-item>

      <div class="redyxz flex_start">
        <el-checkbox v-model="redyxz" />
        <div class="yd">
          我已阅读并接受
          <span @click="showuseragree = true">用户协议</span>和
          <span @click="showuseragree = true">隐私政策</span>
        </div>
      </div>

      <div class="regbtn" @click="submit">注册</div>

      <div class="yyzh">已有帐号，前往<span>登录</span></div>
    </el-form>

    <el-dialog
      title="用户协议"
      center
      :visible.sync="showuseragree"
      width="50%"
    >
      <div class="diacont">
        您在登录、注册、使用华律产品/服务，以及点击同意本协议之前，应当认真、审慎的阅读和充分理解本协议各条款，以及本协议项下某项服务的单独协议或特别条款的内容；特别是免除和限制责任的条款、法律责任条款、法律适用和争议解决条款以及其它以加粗加黑和/或加下划线等显示形式提示您注意的重要条款。如您对本协议有任何疑问或需要华律说明，您可通过访问https://www.66law.cn/help/feedback.aspx“意见反馈”、华律在线客服、发送邮件fankui@66law.cn或拨打华律客服电话等多种方式与我们联系，以便我们为您做出解答。
        您在登录、注册、使用华律产品/服务，以及点击同意本协议之前，应当认真、审慎的阅读和充分理解本协议各条款，以及本协议项下某项服务的单独协议或特别条款的内容；特别是免除和限制责任的条款、法律责任条款、法律适用和争议解决条款以及其它以加粗加黑和/或加下划线等显示形式提示您注意的重要条款。如您对本协议有任何疑问或需要华律说明，您可通过访问https://www.66law.cn/help/feedback.aspx“意见反馈”、华律在线客服、发送邮件fankui@66law.cn或拨打华律客服电话等多种方式与我们联系，以便我们为您做出解答。
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    var validatorPhone = function (rule, value, callback) {
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    return {
      type: 1,
      yzmtext: "发送验证码",
      yzmtime: 60,
      disabled: true, //是否可以获取验证码
      pwdshow: false, //是否显示密码
      redyxz: false, //是否勾选阅读须知
      form: {
        phone: "",
      },
      rules: {
        phone: [{ validator: validatorPhone, trigger: "blur" }],
      },
      showuseragree: false,
    };
  },
  beforeMount() {
    this.$parent._data.currentactep = 2;
  },
  methods: {
    changetype(index) {
      this.type = index;
      this.$refs.form.resetFields()
    },
    // 获取验验证码
    getyzm() {
      if (this.yzmtime > 1) {
        this.disabled = false;
        this.yzmtime--;
        this.yzmtext = this.yzmtime + "秒";
        setTimeout(this.getyzm, 1000);
      } else {
        this.yzmtime = 60;
        this.yzmtext = "发送验证码";
        this.disabled = true;
		//获取验证码
		this.$http.user.sendcode({phone:from.phone})
      }
	  
	  
    },
    // 提交
    submit() {
      console.log(this.form);
      // this.$refs['form'].fields[0].validateMessage = "已注册";
      // this.$refs['form'].fields[0].validateState = "error";
      this.$router.push({
        path: "/log/logsig/logsig_3",
      });
    },
    // 手机号失去焦点
    sjhblur(e) {
      console.log(e);
    },
  },
};
</script>

<style lang="scss" scoped>
.logsig_2_1 {
  margin-left: auto;
  margin-right: auto;
  width: 900px;
  background: #ffffff;
  box-shadow: 1px 1px 9px 0px rgba(0, 0, 0, 0.11);
  border-radius: 3px;
  .heatab {
    height: 76px;
    line-height: 76px;
    background: #e5eeff;
    color: #4686ff;
    border-radius: 3px 3px 0px 0px;
    text-align: center;
    font-size: 24px;
    .tabitem {
      flex: 1;
      &.tabitemact {
        background: #0057ff;
        color: #ffffff;
      }
    }
  }
  .form {
    margin-left: auto;
    margin-right: auto;
    padding-top: 50px;
    padding-bottom: 90px;
    width: 340px;
    .formeliten {
      width: 100%;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      background: #ffffff;
      position: relative;
      .yzm {
        width: 214px;
        height: 40px;
        border-radius: 3px;
      }
      .getyzm {
        width: 110px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #0057ff;
        color: #ffffff;
        border-radius: 3px;
        font-size: 14px;
        &.djs {
          background: #4b74c5;
        }
      }
      .pwd {
        width: 100%;
      }
      .pwdicon {
        position: absolute;
        right: 10px;
        top: 0;
      }
    }

    .redyxz {
      margin-top: 24px;
      .yd {
        margin-left: 10px;
        font-size: 14px;
        color: #666666;
        letter-spacing: 2px;
        span {
          color: #d36f16;
          cursor: pointer;
        }
      }
    }
    .regbtn {
      cursor: pointer;
      width: 336px;
      margin: 30px auto 0;
      height: 44px;
      text-align: center;
      line-height: 44px;
      border-radius: 3px;
      font-size: 18px;
      background: #0057ff;
      color: #ffffff;
    }

    .yyzh {
      margin-top: 20px;
      font-size: 14px;
      color: #333333;
      letter-spacing: 2px;
      span {
        cursor: pointer;
        color: #0057ff;
      }
    }
  }
}
</style>